<template>
  <div
    id="menu-bar"
    class="fixed-bottom row justify-center bg-primary menu-bar shadow-10"
  >
    <div class="row col-12 col-sm-8 col-md-4 justify-around">
      <q-btn
        :ripple="{ color: 'white' }"
        flat
        size="15.3px"
        color="white"
        icon="fas fa-home"
        stack
        aria-label="home"
        title="home"
        to="/portal"
      ></q-btn>
      <q-btn
        :ripple="{ color: 'white' }"
        flat
        size="15.3px"
        color="white"
        icon="fas fa-user-circle"
        stack
        aria-label="profile"
        title="profile"
        to="/portal/profile"
        @click="onProfile"
      ></q-btn>
      <!-- <q-btn
        :ripple="{ color: 'white' }"
        flat
        size="15.3px"
        color="white"
        icon="fas fa-shopping-cart"
        stack
        aria-label="cart"
        title="cart"
        to="/portal/cart"
        @click="onCart"
      >
        <q-badge v-if="TotalInStock > 0" color="red" floating>
          {{ TotalInStock }}
        </q-badge>
      </q-btn> -->
    </div>
  </div>
</template>

<script>

import { QBtn } from "quasar";
const components = { QBtn };

export default {
  name: "MenuBar",
  components: {
    ...components,
  },
  methods: {
      onProfile(){
          return
      },
      onCart(){
          return
      },
  }
};
</script>

<style></style>
